import { gql } from '@apollo/client'

export const PROJECT_DETAIL_QUERY = gql`
  query ProjectDetail($projectId: ID!) {
    project(id: $projectId) {
      id
      browsePath
      budgetMax
      guestCount
      requestedDates
      roomType
      nexusProjectId
      nexusIntegratedFeatures
      eventCategory {
        id
        name
        isB2c
      }
    }
  }
`
